/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiContact, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ContactsController.
 */
export class ContactsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /contacts:prefill
     */
    public createPrefilled(): Promise<Result<ApiContact>> {
        return this.http.post<Result<ApiContact>, undefined>('/contacts:prefill', undefined);
    }

    /**
     * Calls POST /contacts/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiContact>>> {
        return this.http.post<Result<LockedContextDto<ApiContact>>, undefined>(`/contacts/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /contacts/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiContact>> {
        return this.http.post<Result<ApiContact>, undefined>(`/contacts/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /contacts/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiContact[]>> {
        return this.http.post<Result<ApiContact[]>, string[]>('/contacts/locks', ids);
    }

    /**
     * Calls POST /contacts/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/contacts/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /contacts/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/contacts/${primaryId}/locks`);
    }

    /**
     * Calls GET /contacts/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiContact>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiContact>>(`/contacts/${primaryId}`, query);
    }

    /**
     * Calls POST /contacts
     */
    public add(dto: ApiContact): Promise<Result<ApiContact>> {
        return this.http.post<Result<ApiContact>, ApiContact>('/contacts', dto);
    }

    /**
     * Calls PUT /contacts/{primaryId}
     */
    public update(dto: ApiContact, primaryId: string): Promise<Result<ApiContact>> {
        return this.http.put<Result<ApiContact>, ApiContact>(`/contacts/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /contacts
     */
    public putRange(dtos: ApiContact[]): Promise<Result<ApiContact[]>> {
        return this.http.patch<Result<ApiContact[]>, ApiContact[]>('/contacts', dtos);
    }

    /**
     * Calls DELETE /contacts/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/contacts/${primaryId}`);
    }

    /**
     * Calls POST /contacts:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiContact>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiContact>>, ListRequestWithIds>('/contacts:batch', listRequest, query);
    }

    /**
     * Calls POST /contacts:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiContact>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiContact>>, ListRequest>('/contacts:query', listRequest, query);
    }

    /**
     * Calls GET /contacts:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiContact>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiContact>>>('/contacts:query', query);
    }
}
